"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExpressionType = void 0;
const getExpressionType = (calculatedColumn, api) => {
    var _a;
    return ((_a = calculatedColumn === null || calculatedColumn === void 0 ? void 0 : calculatedColumn.Query) === null || _a === void 0 ? void 0 : _a.AggregatedScalarExpression) == undefined
        ? 'ScalarExpression'
        : api.calculatedColumnApi.internalApi.isCumulativeAggregatedExpression(calculatedColumn.Query.AggregatedScalarExpression)
            ? 'CumulativeAggregatedExpression'
            : api.calculatedColumnApi.internalApi.isQuantileAggregatedExpression(calculatedColumn.Query.AggregatedScalarExpression)
                ? 'QuantileAggregatedExpression'
                : 'AggregatedScalarExpression';
};
exports.getExpressionType = getExpressionType;
